/* unplugin-vue-components disabled */import { render } from "./UserStat.vue?vue&type=template&id=549d4185"
import script from "./UserStat.vue?vue&type=script&lang=js"
export * from "./UserStat.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__